import Api from '@/services/api'

export default {
  async getAvisos () {
    const response = await new Api().get('Avisos/obterAvisos');

    if (!response) return []

    return response.dados
  },
  updateAviso (idAviso) {
    new Api().post('Avisos/atualizarAviso', { idAviso });
  },
  getLocalAvisos () {
    const avisos = localStorage.getItem('alerts')

    if (!avisos) {
      return false
    }

    return JSON.parse(avisos)
  },
  setLocalAvisos (avisos) {
    localStorage.setItem('alerts', JSON.stringify(avisos))
  },
  setAvisos (avisos) {
    if (!avisos) { return false }

    new Api().post('Avisos/criarAviso', { alias: avisos })

    return true
  },
}
